import { Card, Empty } from "antd";

// Placeholder for the nfdump-style flow query UI. Backend work lands in
// a later milestone — for now the page exists so the menu item has a
// target and the routing tree is wired end-to-end.
export default function Flows() {
  return (
    <Card title="Flows">
      <Empty description="Flow query UI coming soon. Use sfflowdump -r wgflow.* on the sensor for now." />
    </Card>
  );
}
